import { Link } from 'react-router-dom'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-throttle-navy-950 border-t border-throttle-cyan-500/20 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="/images/copy_of_grunge_urban_spray_music_studio_logo_(2).png"
                alt="Social Pack"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-sm text-gray-400 text-center md:text-left">
              Professional social media image generation for real estate and mortgage professionals.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/pricing" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                Pricing
              </Link>
              <Link to="/blog" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                Blog
              </Link>
              <Link to="/faq" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                FAQ
              </Link>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/terms" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-throttle-cyan-400 transition-colors">
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-throttle-cyan-500/20">
          <p className="text-sm text-gray-400 text-center">
            &copy; {currentYear} Throttle Labs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
